export const variables = {
  scalePartDefaultName: 'Total',
  units: [
    '%', 'да/нет', 'дня/дней', 'млн', 'руб/гектар', 'руб/голову', 'руб/кг', 'руб/шт',
    'тонн', 'тонна/гектар', 'руб/тонну', 'м3/тонну', 'кВт*ч/тонну', 'Гол/н.н.', 'шт', 'тыс.руб',
    'млн.руб' , 'млн.шт' , 'тыс.шт' , 'л/тонну' , 'гектар' , 'руб/км' , 'л/гектар' , 'л/100км',
  ],
}